import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ArrowUpDown, Star } from 'lucide-react';

interface SortDropdownProps {
  assetType: 'helicopter' | 'engine' | 'parts' | 'jobs' | 'services';
  value: string;
  onChange: (value: string) => void;
}

const SORT_OPTIONS = {
  helicopter: [
    { value: 'featured-first', label: 'Featured First' },
    { value: 'date-desc', label: 'Newest Listed' },
    { value: 'price-asc', label: 'Price: Low to High' },
    { value: 'price-desc', label: 'Price: High to Low' },
    { value: 'year-desc', label: 'Year: Newest First' },
    { value: 'year-asc', label: 'Year: Oldest First' },
    { value: 'hours-asc', label: 'Flight Hours: Low to High' },
    { value: 'hours-desc', label: 'Flight Hours: High to Low' },
  ],
  engine: [
    { value: 'featured-first', label: 'Featured First' },
    { value: 'date-desc', label: 'Newest Listed' },
    { value: 'price-asc', label: 'Price: Low to High' },
    { value: 'price-desc', label: 'Price: High to Low' },
    { value: 'tsn-asc', label: 'TSN: Low to High' },
    { value: 'tsn-desc', label: 'TSN: High to Low' },
    { value: 'tso-asc', label: 'TSO: Low to High' },
    { value: 'tso-desc', label: 'TSO: High to Low' },
  ],
  parts: [
    { value: 'featured-first', label: 'Featured First' },
    { value: 'date-desc', label: 'Newest Listed' },
    { value: 'price-asc', label: 'Price: Low to High' },
    { value: 'price-desc', label: 'Price: High to Low' },
    { value: 'name-asc', label: 'Name: A-Z' },
    { value: 'name-desc', label: 'Name: Z-A' },
    { value: 'condition-new', label: 'Condition: New First' },
    { value: 'condition-used', label: 'Condition: Used First' },
  ],
  jobs: [
    { value: 'featured-first', label: 'Featured First' },
    { value: 'date-desc', label: 'Newest Posted' },
    { value: 'date-asc', label: 'Oldest Posted' },
    { value: 'salary-desc', label: 'Salary: High to Low' },
    { value: 'salary-asc', label: 'Salary: Low to High' },
    { value: 'company-asc', label: 'Company: A-Z' },
    { value: 'company-desc', label: 'Company: Z-A' },
  ],
  services: [
    { value: 'featured-first', label: 'Featured First' },
    { value: 'date-desc', label: 'Newest Listed' },
    { value: 'date-asc', label: 'Oldest Listed' },
    { value: 'name-asc', label: 'Name: A-Z' },
    { value: 'name-desc', label: 'Name: Z-A' },
  ],
};

export const SortDropdown: React.FC<SortDropdownProps> = ({
  assetType,
  value,
  onChange,
}) => {
  const options = SORT_OPTIONS[assetType] || SORT_OPTIONS.helicopter;

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[200px]">
        <ArrowUpDown className="h-4 w-4 mr-2" />
        <SelectValue placeholder="Sort by" />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.value === 'featured-first' && <Star className="h-3 w-3 inline mr-1 text-secondary fill-secondary" />}
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
